import controller from './contact-detail.controller';
import templateBase from './templates/contact-detail.view.html';
import templateAD from './templates/contact-detail-adaptative.html';

let ContactDetailComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

//changeTemplate.$inject = ['SessionService'];

function changeTemplate() {
    /*let response = SessionService.get('components');
    if (response.CONTACT.component == 'template_t1') {
        return templateT1;
    } else {*/
    //}
    if(__env.adaptative){
      return templateAD;
    }else{
      return templateBase;
    }
}

export default ContactDetailComponent



/** WEBPACK FOOTER **
 ** ./www/components/contact-detail/contact-detail.component.js
 **/